import React, { useState, useEffect } from "react";
import axios from "axios";

import { AccountDetailsProvider } from "bundles/AccountDetails/AccountDetailsContainer";
import AccountDetails from "bundles/AccountDetails/components/AccountDetails";
import { BUSINESS_TYPES, US_STATES } from "bundles/AccountDetails/constants";

const AccountDetailsSection = ({
  teamId,
  csrfToken,
  onSave,
}) => {
  const [loading, setLoading] = useState(true);
  const [team, setTeam] = useState(null);
  const [stripePublishableKey, setStripePublishableKey] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
        const response = await axios.get(`/teams/${teamId}/account_details.json`);
        setTeam(response.data.team);
        setStripePublishableKey(response.data.stripePublishableKey);
      } catch (err) {
        setError("Failed to load account details");
      } finally {
        setLoading(false);
      }
    };

    fetchAccountDetails();
  }, [teamId, csrfToken]);

  if (loading) {
    return <div className="text-muted">Loading account details...</div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  return (
    <AccountDetailsProvider
      team={team}
      csrfToken={csrfToken}
      businessTypes={BUSINESS_TYPES}
      usStates={US_STATES}
      stripePublishableKey={stripePublishableKey}
    >
      <AccountDetails onSave={onSave} showPaymentMethods={false} />
    </AccountDetailsProvider>
  );
};

export default AccountDetailsSection;
